<template>
    <div class="app has-header">
        <div class="header main">
            <div class="align-left"></div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right"></div>
        </div>
        <div class="scrollbar-container">
            <div class="page-settings data-input">
                <div class="content">
                    <div class="full">
                        <div class="mainheader">
                            <div class="half">
                                {{ $t('store.structure.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="full">
                        <div class="label" style="text-align: left;">
                            {{ $t('store.structure.help1') }}<br>
                            {{ $t('store.structure.help2') }}<br>
                            {{ $t('store.structure.help3') }}
                        </div>
                    </div>
                    <div class="full">
                        &nbsp;
                    </div>
                    <div class="full">
                        <div class="fourth exact">
                            <div class="full">
                                <div class="full">
                                    <div class="subheader">
                                        {{ $tc('store.structure.businessunit', 2) }}
                                    </div>
                                </div>
                                <div class="full split">
                                    <div class="header">
                                        <div class="label">{{ $tc('store.structure.businessunit') }}</div>
                                    </div>
                                </div>
                                <div v-if="!loading" class="full">
                                    <div v-for="bu in businessunitsStructured" v-bind:key="bu.id"
                                         class="full h34 split-bottom-tight" v-bind:class="{thick: bu.thickborder}">
                                        <div class="twothirds">
                                            <div class="label">{{ bu.name }}</div>
                                        </div>
                                        <div class="third">
                                            <button v-if="!bu.placeholder" class="pill warn-bg"
                                                      @click="openEditBusinessUnitPopup(bu)">
                                                <i class="fas fa-pencil-alt" style="margin-left: -1px;"></i>
                                            </button>
                                            <button v-if="!bu.placeholder" class="pill danger-bg ml5"
                                                      @click="openDeleteBusinessUnitPopup(bu)">
                                                <i class="fas fa-trash" style="margin-left: -1px;"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="half">
                            <div class="full">
                                <div class="full">
                                    <div class="subheader">
                                        {{ $tc('store.structure.spot', 2) }}
                                    </div>
                                </div>
                                <div class="full split marginadapt2">
                                    <div class="fourth exact">
                                        <div class="header">
                                            <div class="label">{{ $tc('store.structure.spot') }}</div>
                                        </div>
                                    </div>
                                    <div class="fourth exact">
                                        <div class="header">
                                            <div class="label">{{ $tc('store.structure.businessunit') }}</div>
                                        </div>
                                    </div>
                                    <div class="fourth exact">
                                        <div class="header">
                                            <div class="label">{{ $tc('store.structure.skill') }}</div>
                                        </div>
                                    </div>
                                    <div class="fourth exact">
                                        <div class="header">
                                            <div class="label">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="full-min split-flat"></div>
                            <div v-if="!loading" class="full">
                                <div v-for="s in spotsStructured" v-bind:key="s.id"
                                     class="full h34 split-bottom-tight marginadapt2"
                                     v-bind:class="{thick: s.thickborder}">
                                    <div class="twenty exact">
                                        <div class="color" v-bind:style="{background: s.color}"
                                             @click="toggleColorPicker(s)">
                                        </div>
                                    </div>
                                    <div class="fifth exact">
                                        <div class="label">&nbsp;&nbsp;{{ s.name }}</div>
                                    </div>
                                    <div class="fourth exact">
                                        <div class="label data">
                                            {{ businessUnitMap[s.unitId] ? businessUnitMap[s.unitId].name : '' }}
                                        </div>
                                    </div>
                                    <div class="fourth exact">
                                        <div class="label">
                                            {{ skillMap[s.requiredSkill] ? skillMap[s.requiredSkill].name : '' }}
                                        </div>
                                    </div>
                                    <div class="fourth exact">
                                        <button class="pill warn-bg" @click="openEditSpotPopup(s)">
                                            <i class="fas fa-pencil-alt" style="margin-left: -1px;"></i>
                                        </button>
                                        <button v-bind:class="{disabled2: s.hasParent}"
                                                class="pill danger-bg ml5" @click="openDeleteSpotPopup(s)">
                                            <i class="fas fa-trash" style="margin-left: -1px;"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fourth exact">
                            <div class="full">
                                <div class="full">
                                    <div class="subheader">
                                        {{ $tc('store.structure.skill', 2) }}
                                    </div>
                                </div>
                                <div class="full split marginadapt4">
                                    <div class="header">
                                        <div class="label">{{ $tc('store.structure.skill') }}</div>
                                    </div>
                                </div>
                                <div v-if="!loading" class="full">
                                    <div v-for="s in skillsStructured" v-bind:key="s.id"
                                         class="full h34 split-bottom-tight marginadapt4"
                                         v-bind:class="{thick: s.thickborder}">
                                        <div class="twothirds">
                                            <div class="label">{{ s.name }}</div>
                                        </div>
                                        <div class="third">
                                            <button v-bind:class="{disabled2: s.hasParent}"
                                                      style="display: inline; width: 28px; height: 28px; margin-top: -4px;" class="pill warn-bg"
                                                      @click="openEditSkillPopup(s)">
                                                <i class="fas fa-pencil-alt" style="margin-left: -1px;"></i>
                                            </button>
                                            <button v-bind:class="{disabled2: s.hasParent}"
                                                      style="display: inline; width: 28px; height: 28px; margin-top: -4px; margin-left: 10px;" class="pill danger-bg ml5" @click="deleteSkill(s)">
                                                <i class="fas fa-trash" style="margin-left: -1px;"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <br/>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                <div style="background-color: #aaa; border: 2px solid #777; color: #444; margin-top: 140px; height: 60px; line-height: 30px; font-size: 14px; border-radius: 12px; padding: 13px;">
                    {{ loadingText }}
                </div>
            </div>
        </div>


    </div>

</template>

<script>
import { Swatches } from 'vue-color';
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'storestructure',
  data () {
    return {
        loading: false,
        loadingText: '',
      businessunits: [],
      buname: "",
      buid:"",
      spots: [],
      skills: [],
      businessunitsStructured: [],
      spotsStructured: [],
      skillsStructured: [],

      spotname: "",
      requiredSkill: "",
      selectedbu:{},
      spotid:"",
      parentId: null,
      color: "#ffffff",
      spoterror: false,
      createWithSkill: true,
      buerror: false,
      createWithSpotAndSkill: false,
      pickers: {}
    }
  },
  components: {
      Swatches
  },
  computed: {
    ...mapGetters(['storeId', 'spotMap', 'businessUnitMap', 'skillMap', 'uiDataMap', 'employeeMap']),
    headerButtons() {
            let view = this;
            let helperLinks = [];
            let buttons = [
                {
                    type: "block",
                    icon: "fa-sync-alt",
                    click: () => {
                       view.refresh(true);
                    },
                    tooltip: this.$t('global.general.refreshData')
                },
                {
                    classes: "add-businessunit",
                    type: "block green border-r",
                    disabled: false,
                    icon: "fa-vector-square",
                    click: ($event) => {
                        this.openNewBusinessUnitPopup($event);
                        },
                    show:  true,
                    tooltip: this.$t('store.structure.addBusinessunit'),
                    title: this.$t('store.structure.addBusinessunit'),
                    helperText: this.$t('store.structure.addBusinessunitHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2049736744"
                },
                {
                    classes: "add-spot",
                    type: "block green border-r",
                    disabled: false,
                    icon: "fa-map-marker",
                    click: ($event) => {
                        this.openNewSpotPopup($event);
                        },
                    show:  true,
                    tooltip: this.$t('store.structure.addSpot'),
                    title: this.$t('store.structure.addSpot'),
                    helperText: this.$t('store.structure.addSpotHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2049736744"
                },
                {
                    classes: "add-skill",
                    type: "block green",
                    disabled: false,
                    icon: "fa-chalkboard-teacher",
                    click: ($event) => {
                        this.openNewSkillPopup($event);
                        },
                    show:  true,
                    tooltip: this.$t('store.structure.addSkill'),
                    title: this.$t('store.structure.addSkill'),
                    helperText: this.$t('store.structure.addSkillHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2049736744"
                }
            ];

            let state= {
                buttons: buttons,
                helperLinks: helperLinks,
                showListIconAlways: true
            };

            state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=ES15Y5i5vKU",
                    externalLabel: this.$t('store.structure.watchTrainingVideoLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                {
                    title: this.$t('store.structure.getSupport'),
                    helperText: this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
                    externalLabel: this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
        return state;
    },
    spotActiveEmployeeCountMap() {

        let map = {};
        Object.values(this.employeeMap).forEach(e => {
            if(e.active && e.spotId != null){
                if(!map[e.spotId]){
                    map[e.spotId] = 0;
                }
                map[e.spotId] +=1;
            }
        });
        return map;
    },
    businessUnitActiveEmployeeCountMap() {

        let map = {};
        Object.values(this.employeeMap).forEach(e => {
            if(e.active && e.spotId != null && this.spotMap[e.spotId]){
                let unitId = this.spotMap[e.spotId].unitId;
                if(!map[unitId]){
                    map[unitId] = 0;
                }
                map[unitId] +=1;
            }
        });
        return map;
    }
  },
  watch: {
    storeId(newVal, oldVal) {
        console.log("Changed storeId: "+newVal);
        this.refresh(true);
    },
    businessUnitMap(newVal, oldVal){

        this.insertParentsAndSort();
    },
    spotMap(newVal, oldVal){
        this.insertParentsAndSort();
    },
    skillMap(newVal, oldVal){

        this.insertParentsAndSort();
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh(false);
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(force = false, showLoadingText=false) {
        this.loadingText = '';
        this.loading = true;
        if(showLoadingText){
            this.loadingText = this.$t('store.structure.loading');
        }
        let view = this;
        view.$helpers.GetUiDataMap(force)
        .then(response => {
            return view.$helpers.GetBusinessUnitMap(force)
        })
        .then(response=>{
            return view.$helpers.GetSkillMap(force);
        })
        .then(response => {
           return view.$helpers.GetSpotMap(force)
        })
        .then(response => {
           return view.$helpers.GetEmployeeMap(force)
        })
        .then(response => {
            view.insertParentsAndSort();
            view.loading = false;
        })
        .catch(function (error) {
            view.loading = false;
            console.log(error)
        });
    },
    instantiateArraysFromMaps(){
        this.businessunits = this.businessUnitMap ? Object.values(this.businessUnitMap) : [];
        this.spots = this.spotMap ? Object.values(this.spotMap) : [];
        this.skills = this.skillMap ? Object.values(this.skillMap) : [];
    },
    insertParentsAndSort(){
        this.instantiateArraysFromMaps();
        this.skills.forEach((skill) => {
            skill.hasParent = false;
            this.spots.forEach(spot => { if(spot.requiredSkill == skill.id) skill.hasParent = true; });
        });
        this.spots.forEach((spot) => {
            spot.hasParent = spot.unitId && spot.isMain;
            this.pickers[spot.id] = false;
        });

        this.businessunits.sort((a, b) => { return  (a.priority == b.priority) ? ((a.name < b.name)? -1 : 1) : ((a.priority < b.priority) ? -1 : 1); });
        this.spots.sort((a, b) => { return  (a.priority == b.priority) ? ((a.name < b.name)? -1 : 1) : ((a.priority < b.priority) ? -1 : 1); });
        this.skills.sort((a,b) => { return (a.name < b.name)? -1 : 1 });

        this.businessunitsStructured = [];
        this.spotsStructured = [];
        this.skillsStructured = [];
        var skillIDs = [];

        this.businessunits.forEach((bu) => {
            bu.thickborder = false;
            var bs = this.buSpots(bu);
            var emptyLines = bs.length - 1;
            if(emptyLines == 0){
                bu.thickborder = true;
            }
            this.businessunitsStructured.push(bu);
            for(var i = 0; i < emptyLines; i++){
                var empty = {
                    name: '',
                    placeholder: true,
                    thickborder: (i == emptyLines - 1)
                }
                this.businessunitsStructured.push(empty);
            }
            for(var i = 0; i < bs.length; i++){
                var spot = bs[i];
                var thick = (i == bs.length - 1);
                spot.thickborder = thick;
                this.spotsStructured.push(spot);
                var skill = this.spotSkill(spot);
                skill.thickborder = thick;
                this.skillsStructured.push(skill);
                skillIDs.push(skill.id);
            }

        });

        this.skills.forEach((skill) => {
            if(!skillIDs.includes(skill.id)){
                this.skillsStructured.push(skill);
            }
        });

    },
    buSpots(bu){
        var spots = [];
        var mainSpot = {};
        var others = [];
        this.spots.forEach((s) => {
            if(s.unitId == bu.id){
                if(s.name == bu.name){
                    mainSpot = s;
                }else{
                    others.push(s);
                }
            }
        });
        spots.push(mainSpot);
        spots = spots.concat(others);
        return spots;
    },
    spotSkill(spot){
        var skill = {};
        this.skills.forEach(s => { if(s.id == spot.requiredSkill) skill = s; });
        return skill;
    },
    toggleColorPicker(spot, val = null){
        let view = this;
        let blacklist = [];
        this.spotsStructured.forEach((s) => {
            if(spot.unitId !== s.unitId) blacklist.push({color: s.color, label: s.name});
        });
        this.$helpers.OpenColorSelection(
            (color) => {
                spot.color = color;
                view.saveColor(spot);
            },
            {
                colorSelected: spot.color,
                colorBlacklist: blacklist
            }
        );
    },
    openNewBusinessUnitPopup(event){
        let view = this;

        let dataEntries = [
            {label: this.$t('store.structure.spotName'), key: 'name', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            {label: this.$t('store.structure.sortPrio'), key: 'priority', hidden: false, type: 'slider', value: 1, slider: {value: 1,
                    min: 1, max: 100, inputControl: true, sliderInput: (x) => {return x}}},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];

        this.$helpers.OpenPopup({
            elRelative: event.currentTarget,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (newBu) {
                    view.createBusinessUnit(newBu);
                }
            },
            header: this.$t('store.structure.newSpot'),
            width: '600px',
            remainAfterSelect: false,
            expanded: true,
        });
    },
    openNewSpotPopup(event){
        let view = this;

        var unitItems = [];
        this.businessunits.forEach((bu) => {
            bu.label = bu.name;
            bu.value = bu.id;
            unitItems.push(bu);
        });

        let employeeLevelItems = [];
        this.uiDataMap.employeeLevels.forEach(level => {
            let item = {label: level.label_de, value: level.id};
            employeeLevelItems.push(item);
        })

        let dataEntries = [
            {label: this.$t('pages.employeeData.name') + ': ', key: 'name', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '342px'}},
            {label: this.$tc('store.structure.spot')+ ': ',key: 'unitId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: unitItems,
                selectMultiple: false,
                selectFirst: true,
                selectedItems: [],
                selectedItem: {},
                onceSelected: function ($event, item, searchbar){
                },
                styleLight: true,
                placeholder: this.$t('store.structure.selectBusinessunit'),
            }, styles: {width: '342px', margin: '8px 0px 0px 0px'}},
            {label: this.$tc('store.structure.employeeLevel') + ': ', key: 'employeeLevel', hidden: false, type: 'dropdownsearch', value: employeeLevelItems[0].value, selectMultiple: false, flexGroup: false, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employeeLevelItems,
                selectMultiple: false,
                selectedItems: [employeeLevelItems[0]],
                selectedItem: employeeLevelItems[0],
                onceSelected: function ($event, item, searchbar){
                },
                styleLight: true,
                placeholder: this.$t('store.structure.selectEmployeeLevel'),
            }, styles: {width: '342px', margin: '8px 0px 0px 0px'}},
            {divider: true},
            {label: this.$t('store.structure.selectSpotColor'), key: 'color', hidden: false, type: 'color', value: view.$helpers.getRandomLightColor(), colorBlacklist: this.spotsStructured.map(s => { return {color: s.color, label: s.name}} )},
            {label: this.$t('store.structure.sortPrio'), key: 'priority', hidden: false, type: 'slider', value: 1, slider: {value: 1,
                    min: 1, max: 100, inputControl: true, sliderInput: (x) => {return x}}},
            {label: this.$t('store.structure.productive'), key: 'productive', hidden: false, type: 'bool', value: true},
            {label: this.$t('store.structure.showMP'), key: 'exportToMp', hidden: false, type: 'bool', value: true},
            {label: this.$t('store.structure.publishMP'), key: 'exportToMz', hidden: false, type: 'bool', value: true},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];

        this.$helpers.OpenPopup({
            elRelative: event.currentTarget,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (newSpot) {
                    view.createSpot(newSpot);
                }
            },
            header: this.$t('store.structure.newSpot'),
            width: '600px',
            remainAfterSelect: false,
            expanded: true,
        });
    },
    openNewSkillPopup(event){
        let view = this;

        let dataEntries = [
            {label: this.$t('pages.employeeData.name') + ': ', key: 'name', hidden: false, type: 'text', value: '', length: 128, styles: {'width': '350px'}},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];

        this.$helpers.OpenPopup({
            elRelative: event.currentTarget,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (newSkill) {
                    view.createSkill(newSkill.name);
                }
            },
            header: this.$t('store.structure.newSkill'),
            remainAfterSelect: false,
            expanded: true,
        });
    },
    createBusinessUnit(bu){
        let view = this;
        let url = '/api/sec/businessunit';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');


        let payload = {
          storeId: this.$store.state.storeId,
          name: bu.name,
          priority: bu.priority,
          createWithSpotAndSkill: true,
        }

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.createdBusinessunit'), view.$t('store.structure.createdBusinessunitMsg'));
            view.refresh(true);
        }).catch(function (error) {
            console.log(error)
        })

    },
    createSpot(newSpotData){
        let view = this;
        let url = '/api/sec/spot';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');

        let payload = {
          unitId: newSpotData.unitId,
          name: newSpotData.name,
          storeId: this.$store.state.storeId,
          color: newSpotData.color,
          priority: newSpotData.priority,
          employeeLevel: newSpotData.employeeLevel,
          createWithSkill: true,
          productive: newSpotData.productive,
          exportToMp: newSpotData.exportToMp,
          exportToMz: newSpotData.exportToMz
        }

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.savedSpot'), view.$t('store.structure.savedSpotMsg'));
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), error);
            console.log(error)
        })

    },
    createSkill(name){
        let view = this;
        let url = '/api/sec/skill';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/skill');
        let payload = {
          storeId: this.$store.state.storeId,
          name: name,
        }

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.savedSkill'), '');
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), error);
            console.log(error)
        })

    },

    openEditBusinessUnitPopup(businessunit){
        let view = this;

        let dataEntries = [
            {label: 'id: ', key: 'id', hidden: true, type: 'text', value: businessunit.id, length: 128, styles: {'width': '350px'}},
            {label: this.$t('pages.employeeData.name') + ': ', key: 'name', hidden: false, type: 'text', value: businessunit.name, length: 128, styles: {'width': '350px'}},
            {label: this.$t('store.structure.sortPrio'), key: 'priority', hidden: false, type: 'slider', value: businessunit.priority,
                slider: {value: businessunit.priority, min: 1, max: 100, inputControl: true, sliderInput: (x) => {return x}}},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];

        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (bu) {
                    view.editBusinessUnit(bu);
                }
            },
            header: this.$t('store.structure.editBusinessunit'),
            width: '600px',
            remainAfterSelect: false,
            centered: true,
            expanded: true,
        });
    },
    editBusinessUnit: function(data){
        let view = this;
        let url = '/api/sec/businessunit';

        let params =  {
            storeId: this.$store.state.storeId
        };
        let payload = {
          id: data.id,
          name: data.name,
          priority: data.priority,
          updateFields: ["name", "priority"]
        }

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.updateMessage'));
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.structure.spotUpdateError'));
        })

    },
    saveColor(spot){
        let view = this;
        let url = '/api/sec/spot';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');

        let payload = {
          id: spot.id,
          color: spot.color,
          updateFields: ["color"]
        }

        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.savedBusinessunitColor'), '');
            view.$store.commit("setSpotMapEntry", spot);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.structure.businessunitColorError'));
            console.log(error)
        })
    },
    openEditSpotPopup(spot){
        let view = this;
        let employeeLevelItems = [];

        this.uiDataMap.employeeLevels.forEach(level => {
            let item = {label: level.label_de, value: level.id};
            employeeLevelItems.push(item);
        });

        let selectedLevel = employeeLevelItems.find(l => l.value == spot.employeeLevel);
        let dataEntries = [
            {label: 'id: ', key: 'id', hidden: true, type: 'text', value: spot.id, length: 128, styles: {'width': '350px'}},
            {label: this.$t('pages.employeeData.name') + ': ', key: 'name', hidden: false, disabled: spot.isMain, type: 'text', value: spot.name, length: 128, styles: {'width': '350px'}},
            {label: this.$tc('store.structure.employeeLevel') + ': ', key: 'employeeLevel', hidden: false, type: 'dropdownsearch', value: spot.employeeLevel, selectMultiple: false, flexGroup: true, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: employeeLevelItems,
                selectMultiple: false,
                selectedItems: [selectedLevel],
                selectedItem: selectedLevel,
                onceSelected: function ($event, item, searchbar){
                },
                styleLight: true,
                placeholder: this.$t('store.structure.selectEmployeeLevel'),
            }, styles: {width: '342px', margin: '8px 0px 0px 0px'}},
            {label: this.$t('store.structure.sortPrio'), key: 'priority', hidden: false, disabled: spot.isMain, type: 'slider', slider:
                    {value: spot.priority, min: 1, max: 100}, value: spot.priority, inputControl: true, sliderInput: (x) => {return x}},
            {label: this.$t('store.structure.productive'), key: 'productive', hidden: false, disabled: false, type: 'bool', value: spot.productive},
            {label: this.$t('store.structure.showMP'), key: 'exportToMp', hidden: false, type: 'bool', value: spot.exportToMp},
            {label: this.$t('store.structure.publishMP'), key: 'exportToMz', hidden: false, type: 'bool', value: spot.exportToMz},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];

        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (spot) {
                    view.editSpot(spot);
                }
            },
            header: this.$t('store.structure.editSpot'),
            width: '600px',
            remainAfterSelect: false,
            centered: true,
            expanded: true,
        });
    },
    editSpot: function(spot){

        let view = this;
        let url = '/api/sec/spot';

        let params = {
            storeId: this.$store.state.storeId
        }
        let payload = {
          id: spot.id,
          name: spot.name,
          priority: spot.priority,
          employeeLevel: spot.employeeLevel,
          productive: spot.productive,
          exportToMp: spot.exportToMp,
          exportToMz: spot.exportToMz,
          updateFields: ["name", "priority", "employeeLevel", "productive", "exportToMp", "exportToMz"]
        }

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.updateMessage'));
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.structure.updateSpotError'));
        })

    },
    openEditSkillPopup(skill){
        let view = this;

        let dataEntries = [
            {label: 'id: ', key: 'id', hidden: true, type: 'text', value: skill.id, length: 128, styles: {'width': '350px'}},
            {label: this.$t('pages.employeeData.name') + ': ', key: 'name', hidden: false, type: 'text', value: skill.name, length: 128, styles: {'width': '350px'}},
            {flexDivider: true, styles: {'margin-bottom': '23px'}},
        ];

        this.$helpers.OpenPopup({
            elRelative: null,
            type: 'datafill',
            pointerDirection: 0,
            componentState: {
                entries: dataEntries,
                selectCallback: function (skill) {
                    view.editSkill(skill);
                }
            },
            header: this.$t('store.structure.editSkill'),
            remainAfterSelect: false,
            centered: true,
            expanded: true,
        });
    },
    editSkill: function(skill){

        let view = this;
        let url = '/api/sec/skill';

        let params = {
            storeId: this.$store.state.storeId
        }
        let payload = {
            id: skill.id,
            name: skill.name,
            updateFields: ["name"]
        }

        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.notifications.updateMessage'));
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('store.structure.updateSkillError'));
        })

    },
    openDeleteBusinessUnitPopup(bu){
        let view = this;
        if(this.businessUnitActiveEmployeeCountMap[bu.id] != null && this.businessUnitActiveEmployeeCountMap[bu.id] > 0){
            window.app.popupalerts.push({header: this.$t('store.structure.deleteBusinessunit'), number: null,
            description: this.$t('store.structure.deleteBusinessunitError'), hidden: false, callbackAccept: function(popup){

                popup.loading = false;
                popup.hidden = true;


            }, callbackCancel: function(popup){
                popup.loading = false;
                popup.hidden = true;
            }
            });
        } else {
            window.app.popupalerts.push({header: this.$t('store.structure.deleteBusinessunit'), number: null,
            description: this.$t('store.structure.deleteBusinessunitQuery') + '<br/> <b style="color: red;">' + this.$t('global.ui.warning') + '!</b><br/>' + this.$t('store.structure.deleteBusinessunitWarn'), hidden: false, callbackAccept: function(popup){



                view.deleteBusinessUnit(bu);

                popup.loading = false;
                popup.hidden = true;


            }, callbackCancel: function(popup){
                popup.loading = false;
                popup.hidden = true;
            }
            });
        }

    },
    deleteBusinessUnit(bu){
        let view = this;
        let url = '/api/sec/businessunit';

        url = this.$helpers.appendParam("id", bu.id, url, '/api/sec/businessunit');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/businessunit');

        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.businessunitDeleted'), view.$t('store.structure.businessunitDeletedMsg'));
            this.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateState', "spotMapState", "businessUnitMapState", "skillMapState", "employeeSkillMapState"]});
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), error);
            console.log(error)
        })

    },
    openDeleteSpotPopup(spot){
        let view = this;
        if(this.spotActiveEmployeeCountMap[spot.id] != null && this.spotActiveEmployeeCountMap[spot.id] > 0){
            window.app.popupalerts.push({header: this.$t('store.structure.deleteSpot'), number: null,
            description: this.$t('store.structure.deleteSpotError'), hidden: false, callbackAccept: function(popup){

                popup.loading = false;
                popup.hidden = true;


            }, callbackCancel: function(popup){
                popup.loading = false;
                popup.hidden = true;
            }
            });
        } else {
            window.app.popupalerts.push({header: this.$t('store.structure.deleteSpot'), number: null,
            description: this.$t('store.structure.deleteSpotQuery1') + '<br/> <b style="color: red;">' + this.$t('global.ui.warning') +
                '</b><br/> ' + this.$t('store.structure.deleteSpotQuery2'), hidden: false, callbackAccept: function(popup){



                view.deleteSpot(spot);

                popup.loading = false;
                popup.hidden = true;


            }, callbackCancel: function(popup){
                popup.loading = false;
                popup.hidden = true;
            }
            });
        }
    },
    deleteSpot(spot){
        let view = this;
        let url = '/api/sec/spot';

        url = this.$helpers.appendParam("id", spot.id, url, '/api/sec/spot');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');


        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.deleteSkill'), view.$t('store.structure.deleteSkillMsg'));
            this.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateState', "spotMapState", "businessUnitMapState", "skillMapState", "employeeSkillMapState"]});
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), error);
            console.log(error)
        })

    },
    deleteSkill(skill){
        let view = this;
        let url = '/api/sec/skill';

        url = this.$helpers.appendParam("id", skill.id, url, '/api/sec/skill');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/skill');

        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            view.$helpers.success(view.$t('store.structure.deleteSkill'), '');
            this.$store.commit("invalidateState", {states: ['planShiftMapState', 'shiftTemplateState', "spotMapState", "businessUnitMapState", "skillMapState", "employeeSkillMapState"]});
            view.refresh(true);
        }).catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), error);
            console.log(error)
        })

    },





    hideModal (ref) {
        this.buerror=false;
        this.buid="";
        this.buname="";
        this.createWithSpotAndSkill = false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .color{
        width: 8px;
        height: 8px;
        border-radius: 100px;
        -webkit-box-shadow: 0 0 0 1px var(--contrast-3);
        box-shadow: 0 0 0 1px var(--contrast-3);
        padding: 0;
        z-index: 999;
        position: relative;
        margin-top: 6px;
        cursor: pointer;
    }
    .color input{
        opacity: 0;

        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        cursor: pointer;
    }
    .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }
    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        overflow-x: hidden;
        top: var(--header-height);
        padding: 0px 14px;
    }


</style>
